import { Provider as ReduxProvider } from "react-redux";
import { msalConfig, msalInstance } from "Auth/authConfig";
import { store } from "./Store/Store";
import { AuthLayout } from "Layout/AuthLayout";
import { ThemeProvider } from "Theme/ThemeProvider";
import { useEffect } from "react";
import "./styles.css";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { useSignalR } from "Common/Hooks";
import { Login } from "./Auth";

function App() {
  const { startConnection, setLogoutResponseCallback } = useSignalR();

  useEffect(() => {
    startConnection();
  }, [startConnection]);

  const handleSSOLogout = async (accountId: string) => {
    const localAccountId = msalInstance.getActiveAccount()?.localAccountId;

    if (localAccountId === undefined || localAccountId === accountId) {
      const logoutRequest = {
        account: msalInstance.getActiveAccount(),
        postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectUri,
      };
      msalInstance.logoutRedirect(logoutRequest);
      localStorage.setItem("isUserLoggedOut", "true");
    } else {
      console.error("Account ID mismatch or account not found. AccountId: ", localAccountId);
    }
  };

  useEffect(() => {
    setLogoutResponseCallback((accountId) => {
      handleSSOLogout(accountId);
    });
  }, [setLogoutResponseCallback]);

  return (
    <ReduxProvider store={store}>
      <ThemeProvider>
        <AuthenticatedTemplate>
          <AuthLayout />
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <Login />
        </UnauthenticatedTemplate>
      </ThemeProvider>
    </ReduxProvider>
  );
}

export default App;
